<template>
  <q-dialog persistent  v-model="alert" :backdrop-filter="backdropFilter">
      <q-card style="width: 500px; max-width: 80vw;">
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">Update Assessment</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>

        <q-card-section >
              <q-form @submit.prevent="onSubmit">
                <div class="q-pa-md">
                  <q-select outlined v-model="topic" :loading="fetchingTopic" :options="topicList" option-value="id" option-label="name" emit-value map-options label="Topic" lazy-rules :rules="[ val => val && val.length > 0 || 'Please select options']"/>
                  <q-input color="indigo-10" outlined label="Assessment" lazy-rules v-model="name" :rules="[ val => val && val.length > 0 || 'Please type something']">
                  </q-input>
                  <q-input
                    color="indigo-10"
                    outlined
                    label="Description"
                    lazy-rules
                    v-model="description"
                    :rules="[ val => val && val.length > 0 || 'Please type something']">
                  </q-input>
                  <q-input type="number" min="1" color="indigo-10" outlined label="Duration in minutes" lazy-rules v-model="duration" :rules="[ val => val && val.length > 0 || 'Please type something']"/>
                  <q-input type="number" min="1" color="indigo-10" outlined label="Total Items" lazy-rules v-model="total_items" :rules="[ val => val && val.length > 0 || 'Please type something']"/>
                  <q-select outlined v-model="difficulty" :options="difficultyOptions" label="Level of Difficulty" />
                  <br/>
                  <div>
                    <q-btn
                      style="background-color: #010127;"
                      color="white-8"
                      rounded
                      class="full-width q-mr-sm"
                      v-ripple
                      size="lg"
                      clickable
                      :loading="isSubmitted"
                      type="submit"
                      >Update Assessment
                    </q-btn>
                  </div>
                </div>
              </q-form>
            </q-card-section>
      </q-card>
    </q-dialog>
</template>

<script>
import { useQuasar } from 'quasar'  
import { ref,onMounted } from 'vue'
import axios from 'axios'
import EventBus from "@/EventBus"

export default {
  
  setup () {
    const token = ref(window.$cookies.get(process.env.VUE_APP_API_KEY).token)
    const $q = useQuasar()
    const backdropFilter = ref('grayscale(100%)')
    const alert = ref(false)
    const isSubmitted = ref(false)
    const topicList = ref([])
    const fetchingTopic = ref(false)
    const difficultyOptions = ref([1, 2, 3, 4, 5])
    const topic = ref(null)
    const id = ref(null)
    const name = ref(null)
    const description = ref(null)
    const duration = ref(null)
    const difficulty = ref(1)
    const total_items = ref(null)
    
    EventBus.on("updateAssessmentModal",(val) => {
        alert.value = val.status
        topic.value = val.obj.topic_id
        id.value = val.obj.id
        name.value = val.obj.name
        description.value = val.obj.description
        duration.value = val.obj.duration
        difficulty.value = val.obj.difficulty
        total_items.value = val.obj.total_items
    })


    function getTopicList (){
        fetchingTopic.value = true
        axios.get(process.env.VUE_APP_API_URL + '/topics/dropdown',{
          headers: { 'Authorization': `Bearer ${token.value}`},
        }).then((res) => {
          topicList.value = res.data
          fetchingTopic.value = false
        })
    }

    onMounted(() => {
      getTopicList()
    })

    return {
      token,
      alert,
      backdropFilter,
      isSubmitted,
      topicList,
      fetchingTopic,
      difficultyOptions,
      topic,
      id,
      name,
      description,
      duration,
      difficulty,
      total_items,
      getTopicList,

      onSubmit () {
        var formData = {
          "id":id.value.trim(),
          "topic_id":topic.value.trim(),
          "name":name.value.trim(),
          "description": description.value.trim(),
          "difficulty": difficulty.value,
          "duration": duration.value,
          "total_items": total_items.value.trim()
        }

        isSubmitted.value = true; 
        axios.put(process.env.VUE_APP_API_URL + '/assessment',formData,{
          headers: { 'Authorization': `Bearer ${token.value}`},
        }).then((response) => {
          if(response.data.status){
            isSubmitted.value = false
            alert.value = false
            $q.notify({
              color: 'positive',
              textColor: 'white',
              icon: 'check_circle',
              message: response.data.message
            })
          EventBus.emit("refreshAssessment")
          }else{
            isSubmitted.value = false
            $q.notify({
              color: 'negative',
              textColor: 'white',
              icon: 'warning',
              message: response.data.message
            })
          }
        }).catch((e) => {
           isSubmitted.value = false
           $q.notify({
              color: 'negative',
              textColor: 'white',
              icon: 'warning',
              message: e.response.data.message
            })
        })
      }

    }
  },
}
</script>